module.exports = __webpack_public_path__ + "img/socar-logo.969a70bd.svg";